// extracted by mini-css-extract-plugin
module.exports = {"blogReviewer":"az_qr","reviewerText":"az_rr","withVerticalPadding":"az_sr","withDate":"az_tr"};